<div class="container kite-container">

    <div class="row">
        <div class="col-6">
            <button type="button" class="btn-back kite-btn-back" aria-label="Close" [routerLink]="['/dashboard' + regresar + '/' + tipoMenu]">
                <!-- <span aria-hidden="true">&times;</span> -->
                <span class="mr-2">&#60;</span>Back
              </button>
        </div>
        <div class="col-6">
            <h3 class="float-right mr-3">PROSPECT AND INSTALLATION FORM</h3>
            <br>
        </div>
    </div>

    <div class="row animated fadeIn mt-2">
        <div class="col-12">
            <div class="card">
                <div class="card-body border bg-white" style="border-radius:15px!important; border-color:#08b9f2!important;">
                    <form [formGroup]="clientForm">
                        <div class="row">
                            <div class="col-md-6">
                                <label class="label" for="name_client"><strong>RESTAURANT</strong></label>
                                <input type="text" class="kite-form-control form-control" id="name_client" placeholder="" formControlName="name_client" toUppercase>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label for="address" class="label">Address</label>
                                <input type="text" class="kite-form-control form-control" id="address" placeholder="" formControlName="address" toUppercase>
                            </div>

                            <div class="col-md-2 mb-3">
                                <label for="area" class="label">Area</label>
                                <input type="text" class="kite-form-control form-control" id="area" placeholder="" formControlName="area" toUppercase>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <br>

    <!-- Form row -->
    <div class="row animated fadeIn mt-1">
        <div class="col-12">
            <div class="card">
                <div class="card-body border bg-white" style="border-radius: 15px!important;">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8" [hidden]="!imgViewHide">
                            <div class="card animated fadeIn">
                                <div class="card-body">
                                    <button type="button " class="btn-close float-right" aria-label="Close " (click)="closeImgView()"></button>
                                    <div class="text-center p-3">
                                        <img *ngIf="!fileData" class="img-fluid animated fadeIn" [src]="imgView | imagen: 'orders'">
                                        <img *ngIf="fileData" class="img-fluid animated fadeIn" [src]="fileData">
                                        <h4 *ngIf="fileData" class="card-subtitle mt-1">{{imgView | uppercase}}</h4>
                                        <br>
                                        <button type="button" *ngIf="!fileData" [href]="pathFile" class="mt-2" target="_blank" download>{{imgView | uppercase}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- **Survey Form -->
                        <div class="col">
                            <form [formGroup]="surveyForm" (ngSubmit)="newSurvey()" autocomplete="off" ngNativeValidate>
                                <div class="row">
                                    <!-- ** Fields Form -->

                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8" [hidden]="imgViewHide">
                                        <!-- **Firts Row -->
                                        <div class="row m-0 p-0">
                                            <div class="col-md-4 mb-3">
                                                <label for="tanksize" class="label">Capacity / week needed</label>
                                                <input type="number" min="0" class="form-control" id="tanksize" placeholder="" formControlName="capacity" [class.is-invalid]="capacityNoValido">
                                                <small *ngIf="capacityNoValido" class="animated fadeIn text-danger">
                                            *Required
                                        </small>
                                            </div>
                                            <div class="col-md-4">
                                                <label class="label">Room Available (Inches)</label>
                                                <div class="row m-0 p-0">
                                                    <div class="col mb-3 px-1">
                                                        <!-- <label for="width" class="label">Room Available</label> -->
                                                        <input type="number" min="0" class="form-control" id="width" placeholder="W" formControlName="room_w">
                                                    </div>
                                                    <div class="col mb-3 px-1">
                                                        <!-- <label for="deep" class="form-label text-white">D</label> -->
                                                        <input type="number" min="0" class="form-control" id="deep" placeholder="D" formControlName="room_d">
                                                    </div>

                                                    <div class="col mb-3 px-1">
                                                        <!-- <label for="height" class="form-label text-white">H</label> -->
                                                        <input type="number" min="0" class="form-control" id="height" placeholder="H" formControlName="room_h">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <label class="label" for="best-date">Schedule job</label>
                                                <div class="input-group input-group-sm">
                                                    <input type="datetime-local" class="form-control kite-imput" id="best-date" name="best_date" formControlName="best_date">
                                                    <!-- <input type="text" class="form-control" placeholder="06/07/2022 03:00pm" formControlName="best_date" toUppercase>
                                            <span class="input-group-text">
                                            <i class="fa fa-calendar"></i>
                                            </span> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div style="margin: 0% 3% 0% 3%;">
                                            <label class="label">Tank Access</label>
                                            <div class="row" style="border:solid 1px #08b9f2; border-radius:15px; ">
                                                <div class="col-sm-2" style="display: flex; align-items: center">
                                                    <div class="form-check form-check-inline m-0 p-0">
                                                        <input class="form-check-input" type="radio" name="tank_acces" id="tank_acces1" value="indoor" formControlName="tank_acces">
                                                        <label class="label" for="tank_acces1">Indoor</label>
                                                    </div>
                                                </div>
                                                <div class="col-sm-3 mb-3">
                                                    <label for="smallAccess" class="label">Smaller Access Width</label>
                                                    <input type="number" class="form-control" id="smallAccess" placeholder="Inches" formControlName="smaller_access">
                                                </div>
                                                <div class="col-sm-2" style="display:flex; align-items:center;">
                                                    <div class="form-check form-check-inline ml-1 p-0">
                                                        <input class="form-check-input" type="radio" name="tank_acces" id="tank_acces2" value="outdoor" formControlName="tank_acces">
                                                        <label class="label" for="tank_acces2">Outdoor</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label for="tanksize" class="label">Door Hinge Side</label>
                                                    <input type="number" min="0" class="form-control" id="tanksize" placeholder="Inches" formControlName="door_hinge_side">
                                                </div>
                                            </div>
                                        </div>
                                        <!-- **Second Row -->
                                        <div class="row m-0 p-0" style="margin-top:2%!important">
                                            <div class="col-md-12 mb-3">
                                                <label for="tanksize" class="label">Tank & Stand Kind</label>
                                                <input type="text" class="form-control" id="tanksize" formControlName="stand_kind" toUppercase>
                                            </div>
                                        </div>

                                        <!-- **Third Row -->
                                        <div class="row m-0 p-0">

                                            <div class="col-md-3 mb-3">
                                                <label for="smallAccess" class="label">Pull for <br>Delivery</label>
                                                <input type="number" min="0" class="form-control" id="smallAccess" placeholder="Feet" formControlName="pull_delivery">
                                            </div>
                                            <div class="col-md-3 mb-3">
                                                <label for="tanksize" class="label">Electrical outlet distance</label>
                                                <input type="number" min="0" class="form-control" id="tanksize" placeholder="Feet" formControlName="electrical_outlet">
                                            </div>
                                            <div class="col-md-3 mb-3">
                                                <label for="tanksize" class="label">Permanent <br>Hose</label>
                                                <input type="number" min="0" class="form-control" id="tanksize" placeholder="Feet" formControlName="permanent_hose">
                                            </div>
                                            <div class="col-md-3 mb-3">
                                                <label for="tanksize" class="label">Dispensing <br>Hose</label>
                                                <input type="number" min="0" class="form-control" id="tanksize" placeholder="Feet" formControlName="dispensing_hose">
                                            </div>

                                        </div>

                                        <!-- **Last Row -->
                                        <div class="row m-0 p-0">

                                            <div class="col-12">

                                                <label for="floatingTextarea" class="label">Special Requirements</label>
                                                <textarea class="form-control" placeholder="" id="floatingTextarea" style="height: 100px" formControlName="special_requirements" oninput="this.value = this.value.toUpperCase();"></textarea >


                                    </div>
                                </div>

                                    </div>

                            <!-- **--Table files--------------- -->
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12"  [class.col-xl-4]="!imgViewHide" >
                                <div class="row">
                                    <div class="col">
                                        <label class="label" for="preSurveyUploadFiles">Upload files</label>
                                        <div class="input-group input-group-sm">
                                            <input id="preSurveyUploadFiles" #inputfile type="file" style="width:100%!important;" class="border border-1 rounded-start" placeholder="" (change)="setFile($event.target.files[0])">
                                            <span class="input-group-text btn-themecolor rounded-end pointer" style="margin-top: 15px!important;" (click)="showFiles()">
                                            Upload File
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col">
                                        <table class="kite-table">
                                            <thead class="bg-light border-secondary">
                                                <tr class="text-center">
                                                    <th class="border" colspan="2" scope="col">Documents Uploaded ({{files_arr.length}})</th>
                                                </tr>
                                            </thead>
                                            <tbody class="tbody-scroll">
                                                <tr *ngFor="let file of files_arr">

                                                    <td class="td-scroll text-center">
                                                        <button type="button" class="btn btn-link p-0" data-toggle="tooltip" data-original-title="Delete" title="Delete" aria-label="Delete file" (click)="removeFile(file)">
                                                            <i class="fa fa-trash text-inverse" aria-hidden="true"></i>
                                                        </button>
                                                    </td>
                                                    <td class="td-scroll w300">{{file.name}}</td>
                                                   <td class="td-scroll text-center">
                                                  <button type="button" class="pointer" data-toggle="tooltip" data-original-title="Show" (click)="getFile(file)">
                                                      <i class="fa fa-eye text-inverse"></i>
                                                  </button>
                                                 </td>

                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>

                      <div class="row">
                        <div class="col-12">
                          <div class="d-flex float-right">
                            <button type="button" type="button" *ngIf="clientSelected" class="btn btn-themecolor mt-4 kite-button float-right mr-3"  [routerLink]="['/dashboard', 'sa-agreement', clientSelected._id, 'main', tipoMenu]" [hidden]="btnSAHide">SERVICE AGREEMENT</button>
                            <button type="submit" class="btn btn-themecolor mt-4 kite-button float-right" [disabled]="!btnSAHide">CREATE PROSPECT</button>
                          </div>
                        </div>
                      </div>

                            </form>
                        </div>
                    </div>



                </div>
                <!-- end card-body -->
            </div>
            <!-- end card-->
        </div>
        <!-- end col -->
    </div>
    <!-- end row -->
</div>
